import {useDispatch, useSelector} from "react-redux";

import {
    updateCdpStatus,
    updateCdpStatusByContract
} from "../../ContractDataPoint/ContractDataPointClient";

import { changeCrudSnackbar } from "../../CommonComponents/crudSnackbarSlice";
import { changeRowSelect } from "../../Menus/rowSelectSlice";
import {changeWorkIssuance} from "../workIssuanceSlice";
import {useEffect} from "react";



export default function useWorkIssuanceGridControls({
                                                        contracts,
                                                        selectedCdps,
                                                        setSelectedCdps,
                                                        selectedContractIds,
                                                        setSelectedContractIds,
                                                        selectedVersionNumber,
                                                        setSelectedVersionNumber,
                                                        setSubmitting,

                                                        // lets each grid supply its own slice action
                                                        changeGridState
                                                    }) {

    const dispatchData = useDispatch();


    const STATUS_CONFIG = {
        "3208": {
            successMessage: "Records blocked",
            errorMessage: "Blocking failed",
            stateToClear: "deferState"
        },
        "2043": {
            successMessage: "Records deferred",
            errorMessage: "Deferral failed",
            stateToClear: "deferState"
        },
        "2602": {
            successMessage: "Records flagged",
            errorMessage: "Flagging failed",
            stateToClear: "flagState"
        },
        "3709": {
            successMessage: "Records marked as history",
            errorMessage: "History update failed",
            stateToClear: "historyState"
        },
        "2041": {
            successMessage: "Records put on hold",
            errorMessage: "Hold failed",
            stateToClear: "holdState"
        },
        "3242": {
            successMessage: "Records marked as issued",
            errorMessage: "Issued update failed",
            stateToClear: "issuedState"
        },
        "3410": {
            successMessage: "Records marked as omitted",
            errorMessage: "Omitted update failed",
            stateToClear: "omittedState"
        },
        "2351": {
            successMessage: "Records marked as paid",
            errorMessage: "Paid update failed",
            stateToClear: "paidState"
        },
        "4553": {
            successMessage: "Records marked as remit received",
            errorMessage: "Receiving failed",
            stateToClear: "receivedState"
        },
        "2042": {
            successMessage: "Records rejected",
            errorMessage: "Rejection failed",
            stateToClear: "rejectedState"
        },
        "2359": {
            successMessage: "Records requested for payment",
            errorMessage: "Request failed",
            stateToClear: "requestedState"
        },
        "2040": {
            successMessage: "Records unapproved",
            errorMessage: "Unapproval failed",
            stateToClear: "unapproveState"
        }
    };


    const triggerCdpStatusUpdate = useSelector(
        state => state.workIssuanceSlc.value.updateCdpStatus
    );

    const statusId = useSelector(
        state => state.workIssuanceSlc.value.newStatus
    );





    const handleUpdateCdpStatus = () => {
        console.log("handleUpdateCdpStatus");
        if (
            selectedCdps.length === 0 ||
            statusId == null
        ) {
            dispatchData(changeWorkIssuance({
                updateCdpStatus: false
            }));

            return;
        }

        const normalizedStatusId = String(statusId);
        const statusConfig = STATUS_CONFIG[normalizedStatusId];

        if (!statusConfig) {
            console.error(
                `No status configuration found for ${normalizedStatusId}`
            );

            dispatchData(changeCrudSnackbar({
                crudOpen: true,
                crudSeverity: "error",
                crudMessage: "Invalid status selected"
            }));

            dispatchData(changeWorkIssuance({
                updateCdpStatus: false,
                newStatus: null
            }));

            return;
        }

        const {
            successMessage,
            errorMessage,
            stateToClear
        } = statusConfig;

        setSubmitting(true);

        const cdpIds = selectedCdps
            .map(id => parseInt(id, 10))
            .join(",");

        updateCdpStatus(normalizedStatusId, cdpIds)
            .then(() => {
                dispatchData(changeCrudSnackbar({
                    crudOpen: true,
                    crudSeverity: "success",
                    crudMessage: successMessage
                }));
            })
            .catch(err => {
                console.error(err);

                dispatchData(changeCrudSnackbar({
                    crudOpen: true,
                    crudSeverity: "error",
                    crudMessage: errorMessage
                }));
            })
            .finally(() => {
                setSubmitting(false);

                dispatchData(changeWorkIssuance({
                    [stateToClear]: false,
                    updateCdpStatus: false,
                    newStatus: null,
                    expenseGridRefresh: true,
                    owedGridRefresh: true
                }));
            });
    };

    useEffect(() => {
        if (triggerCdpStatusUpdate === true) {
            handleUpdateCdpStatus();
        }
    }, [triggerCdpStatusUpdate]);


    // ************************************************************
    // STATUS HANDLERS
    // ************************************************************
    //
    //
    // const handleBlocked = () =>
    //     handleUpdateCpdStatus({
    //         statusId: "3208",
    //         successMessage: "Records blocked",
    //         errorMessage: "Blocking failed",
    //         stateToClear: "deferState"
    //     });
    //
    //
    // const handleDefer = () =>
    //     handleUpdateCpdStatus({
    //         statusId: "2043",
    //         successMessage: "Records deferred",
    //         errorMessage: "Deferral failed",
    //         stateToClear: "deferState"
    //     });
    //
    //
    //
    // const handleFlag = () =>
    //     handleUpdateCpdStatus({
    //         statusId: "2602",
    //         successMessage: "Records flagged",
    //         errorMessage: "Flagging failed",
    //         stateToClear: "flagState"
    //     });
    //
    // const handleHistory = () =>
    //     handleUpdateCpdStatus({
    //         statusId: "3709",
    //         successMessage: "Records marked as history",
    //         errorMessage: "History update failed",
    //         stateToClear: "historyState"
    //     });
    //
    //
    // const handleHold = () =>
    //     handleUpdateCpdStatus({
    //         statusId: "2041",
    //         successMessage: "Records put on hold",
    //         errorMessage: "Hold failed",
    //         stateToClear: "holdState"
    //     });
    //
    //
    // const handleIssued = () =>
    //     handleUpdateCpdStatus({
    //         statusId: "3242",
    //         successMessage: "Records marked as issued",
    //         errorMessage: "Issued update failed",
    //         stateToClear: "issuedState"
    //     });
    //
    //
    //
    // const handleOmitted = () =>
    //     handleUpdateCpdStatus({
    //         statusId: "3410",
    //         successMessage: "Records marked as omitted",
    //         errorMessage: "Omitted update failed",
    //         stateToClear: "omittedState"
    //     });
    //
    //
    //
    // const handlePaid = () =>
    //     handleUpdateCpdStatus({
    //         statusId: "2351",
    //         successMessage: "Records marked as paid",
    //         errorMessage: "Paid update failed",
    //         stateToClear: "paidState"
    //     });
    //
    //
    // const handleReceived = () =>
    //     handleUpdateCpdStatus({
    //         statusId: "4553",
    //         successMessage: "Records marked as remit received",
    //         errorMessage: "Receiving failed",
    //         stateToClear: "receivedState"
    //     });
    //
    //
    // const handleReject = () =>
    //     handleUpdateCpdStatus({
    //         statusId: "2042",
    //         successMessage: "Records rejected",
    //         errorMessage: "Rejection failed",
    //         stateToClear: "rejectedState"
    //     });
    //
    //
    // const handleRequested = () =>
    //     handleUpdateCpdStatus({
    //         statusId: "2359",
    //         successMessage: "Records requested for payment",
    //         errorMessage: "Request failed",
    //         stateToClear: "requestedState"
    //     });
    //
    //
    //
    // const handleUnapprove = () =>
    //     handleUpdateCpdStatus({
    //         statusId: "2040",
    //         successMessage: "Records unapproved",
    //         errorMessage: "Unapproval failed",
    //         stateToClear: "unapproveState"
    //     });
    //

    // ************************************************************
    // APPROVE
    // Different from other status changes because this operates
    // by contract + version instead of CDP.
    // ************************************************************

    const handleApprove = () => {
        console.log("handleApprove triggered in the useWorkIssuanceGridControls.jsx file.");
        console.log("selectedCdps = ", selectedCdps);
        console.log("selectedContractIds = ", selectedContractIds);
        console.log("selectedVersionNumber = ", selectedVersionNumber);
        console.log("statusId = ", statusId);
        if (selectedCdps.length === 0) return;
        if (statusId !== '2039' ) return;
        dispatchData(changeCrudSnackbar({
            crudOpen: true,
            crudSeverity: "info",
            crudMessage: "Approval initiated"
        }));
        console.log("handleApprove validations passed");
        setSubmitting(true);

        const contractIds = selectedContractIds
            .map(id => parseInt(id))
            .join(",");

        const versionNumbers = selectedVersionNumber
            .map(id => parseInt(id))
            .join(",");

        updateCdpStatusByContract(
            "2039",
            contractIds,
            versionNumbers
        )
            .then(() => {

                dispatchData(changeCrudSnackbar({
                    crudOpen: true,
                    crudSeverity: "success",
                    crudMessage: "Records approved"
                }));

            })
            .catch(err => {

                console.log(err);

                dispatchData(changeCrudSnackbar({
                    crudOpen: true,
                    crudSeverity: "error",
                    crudMessage: "Approval failed"
                }));

            })
            .finally(() => {

                setSubmitting(false);

                dispatchData(changeGridState({
                    approvedState: false,
                    newStatus: null
                }));

                dispatchData(changeWorkIssuance({
                    owedGridRefresh: true
                }));

            });
    };


    // ************************************************************
    // ROW SELECTION
    // ************************************************************

    const handleMousedRow = (data) => {

        const matchingRecords = contracts.filter(
            contract =>
                contract.hierarchy.includes(data.hierarchy) &&
                contract.cdpId !== null
        );


        const cdpIds = matchingRecords.map(
            item => `${item.cdpId}`
        );


        const contractIds = [
            ...new Set(
                matchingRecords.map(item => item.contractId)
            )
        ];


        const versionNumbers = [
            ...new Set(
                matchingRecords.map(item => item.versionNumber)
            )
        ];


        setSelectedCdps(cdpIds);
        setSelectedContractIds(contractIds);
        setSelectedVersionNumber(versionNumbers);


        dispatchData(changeRowSelect({
            contractId: data.contractId,
            contractSectionId: data.contractSectionId,
            cdpId: data.cdpId,
            cdpvId: data.cdpvId,
            cdpvfId: null,
            csfId: null,
            status: data.status,
            cdpList: cdpIds
        }));
    };


    return {
        handleApprove,
        // handleBlocked,
        // handleDefer,
        //
        // handleFlag,
        // handleHistory,
        // handleHold,
        // handleIssued,
        // handleUnapprove,
        // handleOmitted,
        // handlePaid,
        // handleReceived,
        // handleReject,
        // handleRequested,

        handleMousedRow
    };
}